import { render, staticRenderFns } from "./parcelasChart.vue?vue&type=template&id=52d32667&scoped=true"
import script from "./parcelasChart.vue?vue&type=script&lang=js"
export * from "./parcelasChart.vue?vue&type=script&lang=js"
import style0 from "./parcelasChart.vue?vue&type=style&index=0&id=52d32667&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d32667",
  null
  
)

export default component.exports